import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getSchedulingCarouselCardStyles = () => {
  return StyleSheet.create({
    carouselContainer: {
      width: '100%',
      marginBottom: tokens.spacing.SPACING_16
    },
    carouselHeaderContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: tokens.spacing.SPACING_16
    },
    actionCtaStyle: {
      paddingLeft: tokens.spacing.SPACING_36
    }
  });
};